module.exports = __webpack_public_path__ + "static/media/Keywords_Template_v2.b70ff01e.xlsx";